<template>
  <div>
    <div class="intro-container">
      <div class="container-1000">
        <div class="intro-section">
          <h1 class="text-center">
            Schuette® Plissees, Rollos & Vorhänge zum Verlieben für Ihr Zuhause!
          </h1>

          <div class="grid-1-2-1 category-intro-photos category-intro-videos is-hidden-mobile">
            <div class="grid-item">
              <app-image
                src="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg"
                alt="rollos"
                lazy
              />
              <nuxt-link :to="localePath('categories-roller-blinds')" class="intro-photo-button">
                <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                  Rollos
                </b-button>
              </nuxt-link>
            </div>
            <div class="grid-item">
              <lazy-video :video="{ video: WelcomeVideoThree }" alt="willkommen" />
              <nuxt-link :to="localePath('categories-pleated-blinds')" class="intro-photo-button">
                <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                  Plissees
                </b-button>
              </nuxt-link>
            </div>
            <div class="grid-item">
              <app-image
                src="https://img.schuette.shop/schuette/categories/pleated-blinds/schuette-fabrics-3.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/pleated-blinds/schuette-fabrics-3.jpg"
                alt="plissee"
                lazy
              />
              <nuxt-link :to="localePath('categories-curtains')" class="intro-photo-button">
                <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                  Vorhänge
                </b-button>
              </nuxt-link>
            </div>
          </div>
          <div class="carousel-wrapper category-intro-videos is-hidden-tablet">
            <Carousel
              :coverflow="{ mobile: true, desktop: false }"
              coverflow-centered
              loop
              :visible-items="{ mobile: 1, desktop: 3 }"
              :initial-index="1"
              align-items="flex-start"
            >
              <CarouselItem>
                <div class="grid-item">
                  <app-image
                    src="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg.webp"
                    webp-fallback="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg"
                    alt="rollos"
                    lazy
                  />
                  <nuxt-link :to="localePath('categories-roller-blinds')" class="intro-photo-button intro-photo-button--low">
                    <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                      Rollos
                    </b-button>
                  </nuxt-link>
                </div>
              </CarouselItem>
              <CarouselItem>
                <div class="grid-item">
                  <lazy-video :video="{ video: WelcomeVideoThree }" alt="willkommen" />
                  <nuxt-link :to="localePath('categories-pleated-blinds')" class="intro-photo-button">
                    <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                      Plissees
                    </b-button>
                  </nuxt-link>
                </div>
              </CarouselItem>
              <CarouselItem>
                <div class="grid-item">
                  <app-image
                    src="https://img.schuette.shop/schuette/categories/pleated-blinds/schuette-fabrics-3.jpg.webp"
                    webp-fallback="https://img.schuette.shop/schuette/categories/pleated-blinds/schuette-fabrics-3.jpg"
                    alt="plissee"
                    lazy
                  />
                  <nuxt-link :to="localePath('categories-curtains')" class="intro-photo-button intro-photo-button--low">
                    <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                      Vorhänge
                    </b-button>
                  </nuxt-link>
                </div>
              </CarouselItem>
            </Carousel>
          </div>

          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>Sicht- und Sonnenschutz Fenster Plissees, Rollos, Vorhänge & Wohntextilien</b> von Schuette® direkt bei der Manufaktur im anschaulichen <a href="https://schuette.shop/plissee-ohne-bohren-p10">Schuette® Konfigurator</a>  gestalten und bestellen,</p></li>
              <li><p><b>Übersichtlich Stoff, Größe, Farben und Montageart wählen</b> geht alles an einer Stelle, spielend leicht und in wenigen Sekunden, </p></li>
              <li><p><b>Dank manufaktureigenen Suprafix Befestigungstechniken</b>, selbst entwickelten Farben und lösungsorientierter Gestaltung sind Schuette® Produkte bis ins kleinste Detail auf Fenster, Räume und den Alltag abgestimmt, </p></li>
              <li>
                <p>
                  <b>Aus 100% lokaler Fertigung</b> verbindet Schuette® ausschließlich Ressourcen aus der Region mit erfahrener Expertise im Bereich Fenster Sicht- und Sonnenschutz, Produktentwicklung sowie Schneiderhandwerk,
                </p>
              </li>
              <li><p><b>Die schnelle Lieferung direkt an die Haustür</b> ermöglicht eine Zustellung bereits <b>innerhalb weniger Tage</b>, trotz A bis Z Gestaltungsfreiheit. Wann wir liefern, ist sogar auf der Produktseite noch vor Bestellung jederzeit sichtbar,</p></li>
              <li>
                <p>
                  <b>Der Kundenservice</b> der Schuette® Manufaktur ist 24/7/365 per E-Mail sowie Messenger im Shop erreichbar: Wir sind wirklich immer für Sie da!
                </p>
              </li>
              <li><p><b>Schuette® ist transparent </b>, denn alle Preise sind direkt sichtbar.<br><span style="font-weight: bold; color: #D20311;">Die Versandkosten nach Deutschland & Österreich übernehmen wir</span> ❤️</p></li>
            </ul>
          </div>

          <h2 class="text-center">
            Willkommen bei der Plissee, Rollo & Heimtextilien Schuette® Manufaktur
          </h2>

          <div class="text-container">
            <p class="text-center">
              Wir möchten Ihnen einfach nur Danke sagen! Danke für Ihre Unterstützung, sowie Ihre Wertschätzung unserer Arbeit & Herzblutes, welches wir in die Entwicklung und Produktion Ihrer Plissees, Rollos, Vorhänge und Wohntextilien investieren.
            </p>
            <p class="text-center">
              Sie geben uns unglaublich viel Kraft und wir möchten uns mit den bestmöglichen & mit Leidenschaft hergestellten Produkten hierfür bei Ihnen herzlich bedanken!
            </p>
            <p class="text-center">
              Mit diesen Schuette® Wohnaccessoires sorgen wir für mehr Lebensqualität bei Ihnen zu Hause:
            </p>
          </div>
          <!-- Plissees -->
          <div class="box-gray">
            <div class="is-flex">
              <div class="text">
                <div class="box-gray-title">
                  <pleated-blinds-icon class="box-gray-icon" />
                  <div>
                    <h3>Plissees</h3>
                    <rating-average :average="4.9" />
                  </div>
                </div>
                <p>
                  Plissees sind <b>beidseitig verschiebbar</b>  sowie der <b>kompakteste Fensterschutz </b> und vollständig geschlossen a
                  m Fenster nur wenige Zentimeter hoch. Ein verspanntes Fenster Plissee besteht aus einem horizontal plissierten
                  Stoff, fest verspannt zwischen zwei Profilschienen. An diesen Profilschienen wird das Plissee von oben nach unten
                  sowie von unten nach oben verstellt. Dank der Vier-Punkte-Befestigung mit Verspannung ist ein solcher Plissee
                  Fensterschutz der einzige Sicht- und Sonnenschutz mit einer möglichen Durchsicht, sowohl von oben als auch von
                  unten. Dazu bleibt ein Plissees auch beim Kippen stets nah am Fenster.
                </p>
                <nuxt-link :to="localePath('categories-pleated-blinds')">
                  <b-button
                    class="cta-primary has-text-weight-bold"
                    type="is-primary"
                    rounded
                    icon-right="arrow-right-bold"
                  >
                    Plissees
                  </b-button>
                </nuxt-link>
                <div class="links">
                  <nuxt-link :to="localePath({ name: 'product', params: { productName: 'plissee-ohne-bohren', productId: 10 } })">
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Plissee ohne Bohren
                    </b-button>
                  </nuxt-link>
                  <nuxt-link :to="localePath({ name: 'product', params: { productName: 'schuette-plissee-mit-bohren-nach-mas-premium-kollektion-white-day-weis-suprafix-halterungen', productId: 112 } })">
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Plissee mit Bohren
                    </b-button>
                  </nuxt-link>
                  <nuxt-link :to="localePath({ name: 'product', params: { productName: 'schuette-wabenplissee-verdunklungsplissee-ohne-bohren-nach-mas-blackout-x-honey-moonlight-weis', productId: 10948 } })">
                    <b-button
                      type="is-primary"
                      rounded
                      icon-right="arrow-right-bold"
                      class="cta-white has-text-weight-bold"
                    >
                      Wabenplissee
                    </b-button>
                  </nuxt-link>
                  <nuxt-link :to="localePath({ name: 'product', params: { productName: 'schuette-dachfenster-plissee-nach-mas-premium-kollektion-white-day-weis-profilfarbe-weis', productId: 648 } })">
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Dachfenster Plissee
                    </b-button>
                  </nuxt-link>
                </div>
              </div>
              <app-image
                src="https://img.schuette.shop/schuette/categories/pleated-blinds/dim-out-plissee.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/pleated-blinds/dim-out-plissee.jpg"
                lazy
                alt="dim out plissee"
              />
            </div>
          </div>
          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>6 ausfaltbare Stoffkollektionen</b> mit Lichtfilterung, Blackout Verdunkelung sowie Thermo Wärmeschutz und Lärmschutz,</p></li>
              <li><p><b>In 90 Stofffarben</b> und jeweils 6 Profilfarben, </p></li>
              <li><p><b>Für Senkrechtfenster,</b> Dreh-Kippfenster, Dachfenster und Sonderformen, </p></li>
              <li><p><b>Vormontiert für schnelle Montage</b> mit oder Ohne Bohren,</p></li>
              <li><p><b>Schuette® Qualitätsversprechen</b> inbegriffen,</p></li>
              <li><p><b>Ab 15,99 EUR,</b> Kostenloser Versand nach DE & AT.</p></li>
            </ul>
          </div>

          <div class="has-text-centered box-gray-cta">
            <nuxt-link :to="localePath({ name: 'product', params: { productName: 'plissee-ohne-bohren', productId: 10 } })">
              <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="cta-primary has-text-weight-bold">
                Schuette® Plissee Konfigurator
              </b-button>
            </nuxt-link>
          </div>
          <!-- Rollos -->
          <div class="box-gray">
            <div class="is-flex">
              <div class="text">
                <div class="box-gray-title">
                  <roller-blinds-icon class="box-gray-icon" />
                  <div>
                    <h3>Rollos</h3>
                    <rating-average :average="4.7" />
                  </div>
                </div>
                <p>
                  Rollos sind ein <b>von oben ausrollbarer Fensterschutz</b>  und unten freihängend. Im Gegensatz
                  zu verspannten Plissees bleibt beim Rollo Sicht- und Sonnenschutz der obere Teil des Fensters
                  stets bedeckt. Der Rollostoff ist auf einer Welle aufgewickelt, die seitlich mit einem Kettenzug
                  ausgestattet ist. Über die integrierte Kettenschlaufe lässt sich der Rollostoff auf- und
                  abrollen. Welle und Kettenmechanismus sind gemeinsam in einer Profilschiene integriert. Dank
                  des dort eingesetzten automatischen Kippmechanismus ist eine Rollo Befestigung sowohl vertikal
                  an Fenster oder Wand als auch horizontal an der Decke möglich.
                </p>
                <nuxt-link :to="localePath('categories-roller-blinds')">
                  <b-button
                    class="cta-primary has-text-weight-bold"
                    type="is-primary"
                    rounded
                    icon-right="arrow-right-bold"
                  >
                    Rollos
                  </b-button>
                </nuxt-link>
                <div class="links">
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-verdunkelungsrollo-ohne-bohren-mit-bohren-2in1-nach-mas-kollektion-thermo-blackout-snowflake',
                        productId: 2147,
                      },
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Thermo Blackout Verdunkelungsrollo
                    </b-button>
                  </NuxtLink>
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-tag-und-nacht-rollo-ohne-bohren-mit-bohren-2in1-nach-mas-doppelrollo-kollektion-white',
                        productId: 1966
                      }
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Tag & Nacht Doppelrollo
                    </b-button>
                  </NuxtLink>
                </div>
              </div>
              <app-image
                src="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/rollos/schuette-fabrics-1.jpg"
                alt="rollos"
                lazy
              />
            </div>
          </div>
          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>2 ausrollbare Stoffkollektionen</b> mit verstellbarem Licht- und Sichtschutzgrad oder als Blackout Verdunkelung mit Thermo Wärmeschutz</p></li>
              <li><p><b>In 25 Stofffarben</b> und jeweils 4 Profilfarben, </p></li>
              <li><p><b>Vormontiert für schnelle Montage</b> mit oder Ohne Bohren, </p></li>
              <li><p><b>Schuette® Qualitätsversprechen</b> inbegriffen,</p></li>
              <li><p><b>Ab 11,99 EUR,</b> Kostenloser Versand nach DE & AT.</p></li>
            </ul>
          </div>

          <div class="has-text-centered box-gray-cta">
            <NuxtLink
              :to="localePath({
                name: 'product',
                params: {
                  productName: 'schuette-verdunkelungsrollo-ohne-bohren-mit-bohren-2in1-nach-mas-kollektion-thermo-blackout-snowflake',
                  productId: 2147,
                },
              })"
            >
              <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="has-text-weight-bold cta-primary">
                Schuette® Rollo Konfigurator
              </b-button>
            </NuxtLink>
          </div>
          <!-- Vorhange -->
          <div class="box-gray">
            <div class="is-flex">
              <div class="text">
                <div class="box-gray-title">
                  <curtains-icon class="box-gray-icon" />
                  <div>
                    <h3>Vorhänge</h3>
                    <rating-average :average="5" />
                  </div>
                </div>
                <p>
                  Vorhänge sind ein nach links rechts verschiebbarer und gleichzeitig der <b>großflächigste Fensterschutz.</b>
                  Vorhangstoffe sind meist dicht, grammaturstark und undurchsichtig. Eine leichtere Vorhangvariante sind
                  Gardinen. Im Gegensatz zu Vorhängen sind Gardinen dünner und generell transparent bis halbtransparent,
                  was eine Durchsicht ermöglicht. Die Befestigung von Vorhängen und Gardinen erfolgt über dem Fenster, an
                  der Wand oder Decke an Stangen, Schienen oder Seilen mithilfe von Vorhangzubehör wie Gleitern, Haken,
                  Ringen und Klammern.
                </p>
                <nuxt-link :to="localePath('categories-curtains')">
                  <b-button
                    class="cta-primary has-text-weight-bold"
                    type="is-primary"
                    rounded
                    icon-right="arrow-right-bold"
                  >
                    Vorhänge
                  </b-button>
                </nuxt-link>
                <div class="links">
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-verdunkelungs-vorhang-gardine-mit-sen-nach-mas-millenium-velvet-kollektion-polar-bear-weis-grau-beige',
                        productId: 4163,
                      },
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Vorhang mit Ösen
                    </b-button>
                  </NuxtLink>
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-verdunkelungs-vorhang-gardine-mit-tunnelband-nach-mas-millenium-velvet-kollektion-polar',
                        productId: 4257,
                      },
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Vorhang mit Tunnelband
                    </b-button>
                  </NuxtLink>
                </div>
              </div>
              <app-image
                src="https://img.schuette.shop/schuette/categories/curtains/schuette-fabrics-2.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/curtains/schuette-fabrics-2.jpg"
                alt="Schuette® Verdunkelungsvorhänge"
                lazy
              />
            </div>
          </div>
          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>2 Aufhängungen</b> in Form von Multifunktionsband mit Trio-Level-Schlaufen oder anlauffreien Edelstahl-Ösen,</p></li>
              <li><p><b>Mögliche Anbringung</b> an Stangen, Schienen und Seilsystemen, auch über Eck, </p></li>
              <li><p><b>2 verdunkelnde Stoffkollektionen</b> in samtweich oder seidenglatt mit insgesamt 32 manufaktureigenen Stofffarben,</p></li>
              <li><p><b>Schuette® Qualitätsversprechen</b> inbegriffen,</p></li>
              <li><p><b>Ab 46,99 EUR,</b> Kostenloser Versand nach DE & AT.</p></li>
            </ul>
          </div>

          <div class="has-text-centered box-gray-cta">
            <NuxtLink
              :to="localePath({
                name: 'product',
                params: {
                  productName: 'schuette-verdunkelungs-vorhang-gardine-mit-sen-nach-mas-millenium-velvet-kollektion-polar-bear-weis-grau-beige',
                  productId: 4163,
                },
              })"
            >
              <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="has-text-weight-bold cta-primary">
                Schuette® Vorhang Konfigurator
              </b-button>
            </NuxtLink>
          </div>
          <!-- Bettwäsche -->
          <div class="box-gray">
            <div class="is-flex">
              <div class="text">
                <div class="box-gray-title">
                  <accessories-icon class="box-gray-icon" />
                  <div>
                    <h3>Bettwäsche</h3>
                    <rating-average :average="4.8" />
                  </div>
                </div>
                <p>
                  Als Teil der Wohntextilien umfasst Bettwäsche <b>Laken und Bezüge</b>  für Matratzen, Decken und Kissen.
                  Bei Bettlaken mit Gummi handelt es sich um Spannbettlaken. Bezüge und Hüllen gibt es ebenfalls in
                  mehreren Varianten, so zum Beispiel als Bettdeckenbezüge, Bezüge für Kopfkissen wie auch für dekorative
                  Sofakissen. Die Schneiderei unserer Schuette Manufaktur verarbeitet ihre langjährig gesammelte Textil- und
                  Schneiderexpertise auch in der Bettwäsche. So zeichnet sich Schuette® Bettwäsche unter anderem durch einen
                  besonders stabilen Sitz dank extra Materialumschlag aus und ist zudem besonders komfortabel dank verstecktem
                  Incognito Reißverschluss. Auch die verwendete Schuette® <b>Superfluff-Baumwolle</b>  überzeugt mit Materialtechnologien,
                  von denen so manche Standard Bettwäsche nur träumen kann.
                </p>
                <nuxt-link :to="localePath('categories-relax')">
                  <b-button
                    class="cta-primary has-text-weight-bold"
                    type="is-primary"
                    rounded
                    icon-right="arrow-right-bold"
                  >
                    Bettwäsche
                  </b-button>
                </nuxt-link>
                <div class="links">
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-spannbettlaken-140-x-200-wow-kollektion-fluff-white-weis-100-superfluff-baumwolle',
                        productId: 66843,
                      },
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Spannbettlaken
                    </b-button>
                  </NuxtLink>
                  <NuxtLink
                    :to="localePath({
                      name: 'product',
                      params: {
                        productName: 'schuette-dekorativer-kissenbezug-aus-samt-mit-verdecktem-reisverschluss-millenium-velvet-kollektion',
                        productId: 12589,
                      },
                    })"
                  >
                    <b-button
                      type="is-primary"
                      class="cta-white has-text-weight-bold"
                      rounded
                      icon-right="arrow-right-bold"
                    >
                      Dekokissenbezüge
                    </b-button>
                  </NuxtLink>
                </div>
              </div>
              <app-image
                src="https://img.schuette.shop/schuette/categories/relax/schuette-bettwasche.jpg.webp"
                webp-fallback="https://img.schuette.shop/schuette/categories/relax/schuette-bettwasche.jpg"
                alt="Schuette® Bettwäsche"
                lazy
              />
            </div>
          </div>
          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>Traumhafte Baumwoll-Spannbettlaken</b>  mit dem bislang schnellsten Beziehen dank stilvoller Logo-Richtungsanzeige,</p></li>
              <li><p><b>Samtweiche Millenium Velvet Kissenbezüge</b> mit kuschelfreundlichem Incognito Reißverschluss und exakt passend zu Schuette® Verdunkelungsvorhängen, </p></li>
              <li><p><b>Besonders schonend</b> für Matratzen, Kissen und Decken,</p></li>
              <li><p><b>Schuette® Qualitätsversprechen</b> inbegriffen,</p></li>
              <li><p><b>Ab 9,99 EUR,</b> Kostenloser Versand nach DE & AT.</p></li>
            </ul>
          </div>

          <div class="has-text-centered box-gray-cta">
            <NuxtLink
              :to="localePath({
                name: 'product',
                params: {
                  productName: 'schuette-spannbettlaken-140-x-200-wow-kollektion-fluff-white-weis-100-superfluff-baumwolle',
                  productId: 66843,
                },
              })"
            >
              <b-button type="is-primary" rounded icon-right="arrow-right-bold" class="has-text-weight-bold cta-primary">
                Schuette® Bettwäsche Konfigurator
              </b-button>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
    <div class="company-container">
      <div class="container-1000">
        <div class="company-section">
          <h2>
            Liebe Kundin, lieber Kunde ❤️,
          </h2>
          <p>
            vielen Dank, dass Sie sich die Zeit nehmen, mehr über uns und unsere Schuette® Produkte in Erfahrung zu bringen.
          </p>
          <p class="font-semibold">
            Schuette® Marken-Plissees, Rollos und Sonnenschutzsysteme sowie Wohntextilien werden lokal unter Einhaltung sorgfältiger Handwerkskunst und zu fairen Löhnen aus soliden, langlebigen & modernen Materialien hergestellt.
          </p>
          <p>
            Wir sind eine kleine Manufaktur in Familienhand und wir nutzen, entwickeln & leben unsere Produkte tagein, tagaus. Unser kleines Team setzt alles daran, damit Schuette® Plissee-Rollos und Vorhänge den höchsten Handwerkskunst-Standards gerecht werden, sowie vor allem den Ansprüchen in Ihrem Zuhause, denn wir verstehen was "Zuhause" heißt und was es für Sie bedeutet. Ein Plus an Lebensqualität durch formvollendetes Design und überlegene Funktion am Fenster ist unser Anspruch.
          </p>
          <div class="carousel carousel-wrapper">
            <Carousel
              :initial-index="1"
              :coverflow="{ mobile: true, desktop: false }"
              coverflow-centered
              loop
              :visible-items="{ mobile: 1, desktop: 3 }"
              :gap="20"
              align-items="flex-start"
            >
              <CarouselItem v-for="({src, webpFallback, alt}, index) in carouselImages1" :key="index">
                <div class="carousel-item">
                  <app-image
                    ratio="1by1"
                    :src="src"
                    :webp-fallback="webpFallback"
                    lazy
                    :alt="alt"
                  />
                </div>
              </CarouselItem>
            </Carousel>
          </div>
          <h3 class="text-center">
            Schuette® Qualitäts&shy;versprechen
          </h3>
          <p>
            Wir sind besonders stolz darauf, dass wir Einzelteile wie Halterungen und Spannschuhe unserer Schuette® Produkte selbst entwickeln und somit die gesamte Herstellung in der eigenen Hand halten. Das interne Produktdesign und die Entwicklung ermöglichen es uns, auf jedem einzelnen Schritt strenge Qualitätsstandards zu wahren.
          </p>
          <p>
            Im Vordergrund der Fertigung von Schuette® Markenprodukten steht eine außerordentliche Strapazierfähigkeit und Langlebigkeit aller Komponenten sowie eine unkomplizierte Anwendung bei Ihnen Zuhause. Auch die <b>manufaktureigenen Stofffarben</b>, die bewährte Suprafix Befestigungstechnik sowie der geliebte <b>Perfect-Fit-Service</b>  heben Schuette® Markenprodukte positiv hervor. All dies unterstreichen wir mit unserem authentischen Schuette® Qualitätsversprechen:
          </p>
          <div class="check-list-container">
            <ul class="check-list is-big">
              <li><p><b>Die einfache Anwendung</b> ermöglichen passende Befestigungen für nahezu alle Fenstertypen,</p></li>
              <li><p><b>Wiederholt auf Qualität und Funktion geprüfte und erwiesene Langlebigkeit,</b> auch in großformatigen und schweren Ausführungen sowie unter realistischen klimatischen Bedingungen,</p></li>
              <li>
                <p><b>Dank fundierter Marktkenntnis</b> hat Schuette® immer die aktuellsten Farben, Stoffe und Expertise im Sortiment,</p>
              </li>
              <li>
                <p>
                  <b>Der integrierte UV-Schutz</b> schützt Stoffe und Möbel zuverlässig vor Sonnenschäden und Verblassen,
                </p>
              </li>
              <li><p><b>Die pflegeleichte Handhabung</b> sorgt für ein sorgloses “danach”,</p></li>
              <li>
                <p>
                  <b>Der Schuette® Rundumservice ist 24/7/365,</b>  per E-Mail oder Messenger-Nachricht.
                </p>
              </li>
            </ul>
          </div>
          <div class="grid-1-2-1 category-intro-photos category-intro-videos is-hidden-mobile">
            <div
              v-for="({ src, webpFallback, alt }, index) in carouselImages2"
              :key="index"
              class="grid-item"
            >
              <app-image
                :src="src"
                :webp-fallback="webpFallback"
                lazy
                :alt="alt"
              />
            </div>
          </div>
          <div class="carousel-wrapper category-intro-photos category-intro-videos is-hidden-tablet">
            <Carousel
              :coverflow="{ mobile: true, desktop: false }"
              coverflow-centered
              loop
              :visible-items="{ mobile: 1, desktop: 3 }"
              :gap="20"
              :initial-index="1"
              align-items="flex-start"
            >
              <CarouselItem
                v-for="({ src, webpFallback, alt }, index) in carouselImages2"
                :key="index"
              >
                <div class="grid-item">
                  <app-image
                    :src="src"
                    :webp-fallback="webpFallback"
                    lazy
                    :alt="alt"
                  />
                </div>
              </CarouselItem>
            </Carousel>
          </div>

          <h3 class="text-center">
            Schuette® ist das Original
          </h3>
          <p class="font-semibold is-big">
            Liebe Kunden,
          </p>
          <p>
            <b>Schuette® Markenprodukte sind unnachahmlich, denn</b> Schuette® Produkte sind ein Resultat von jahrelanger Hingabe zum Detail und der fortwährenden Weiterentwicklung unserer einzigartigen internen Technologien.
          </p>
          <p>
            Trotz unverkennbarer Merkmale, wie beispielsweise der <b> in Form und Rundung exakt Schuette® logogetreuen Griffe,</b> gibt es immer mehr Nachahmer, die versuchen, unseren Erfolg zu imitieren. Dabei sind es gerade diese gezielt verborgenen Feinheiten, die Schuette® Produkte zu unvergleichbaren Originalen machen.
          </p>
          <p>
            Wir nehmen es als Kompliment, dass unsere harte Arbeit eine Inspirationsquelle für andere darstellt. Dennoch sollten sie verstehen, dass es unzureichend ist, das Etikett "Premium" zu verwenden oder unsere Bilder und Designs nachzustellen. Ebenso wenig genügt es, unsere hochwertigen Halterungen in minderer Qualität nachproduzieren zu lassen und dann als "Made in Europe" zu deklarieren. Produktnachahmungen können zulasten mittelständischer Unternehmen und familiengeführter Manufakturen wie unserer gehen.
          </p>
          <p>
            Umso wichtiger sind Qualität, Originalität und die Wertschätzung echter Handwerksarbeit.
          </p>
          <p>
            Das Schuette® Original kann nicht reproduziert werden, denn unsere Leidenschaft, Energie und Hingabe, die wir in der Schuette Manufaktur in die Entwicklung, Produktion, den Service und den direkten Kontakt mit Ihnen stecken, sind einzigartig.
          </p>
          <p>
            <b> Warum?</b> Weil wir buchstäblich das leben, was wir schaffen, Tag für Tag. Dank Ihnen, den besten Kunden der Welt, werden wir jeden Tag motivierter, noch fleißiger zu sein.
          </p>
          <p>
            Bitte setzen Sie weiterhin auf Qualität, wenn es um Ihr Zuhause geht, und auf die Schuette® Familien-Manufaktur und auf Menschen, die ihr Leben dafür widmen, Produkte zu schaffen, die Ihr Zuhause bereichern.
          </p>

          <h3 class="text-center">
            Wir als kleines Familien&shy;unternehmen wissen was “Zuhause” heißt
          </h3>
          <p>
            Deswegen entwickeln und produzieren wir unsere Produkte unter Einhaltung höchster Qualitätsstandards in Fertigung und Material und vor allem, um Ihren Standards und Wünschen als Nutzer gerecht zu werden, denn wir schätzen und respektieren Ihr Zuhause.
          </p>
          <div class="company-image">
            <app-image
              src="https://img.schuette.shop/schuette/homepage/de/schuette-unique.jpg.webp"
              webp-fallback="https://img.schuette.shop/schuette/homepage/de/schuette-unique.jpg"
              class="is-hidden-mobile"
              lazy
              alt="Schuette Bedeutung"
            />
            <app-image
              src="https://img.schuette.shop/schuette/homepage/de/schuette-unique-mobile.jpg.webp"
              webp-fallback="https://img.schuette.shop/schuette/homepage/de/schuette-unique-mobile.jpg"
              class="is-hidden-tablet mobile-unique"
              lazy
              alt="Schuette Bedeutung"
            />
          </div>
          <p>Maßgefertigte Plissees und Rollos waren in der Vergangenheit oft deutlich teurer als fertige Standardprodukte.</p>
          <p>
            Der Schuette® Shop ist die Lösung für qualitativ höherwertige Markenprodukte wie Fenster-Plissees zu bezahlbaren und begründeten Preisen: <b> wir als Produzent öffnen Ihnen die Türen direkt zu unserer Manufaktur und so zum direkten Verkauf an Sie als Endkunden</b>, anstatt nur exklusiv an Architekten, Hotels, Restaurants oder renommierte Montagefirmen für Sonnenschutzsysteme wie bisher. Bitte glauben Sie uns, wenn wir sagen, dass uns dies Tag für Tag unglaubliche Freude bereitet. ❤️
          </p>
          <p>
            Es wäre unserer Familie und unserem Team eine Ehre, wenn unsere Produkte in Ihrem Zuhause mit den Sonnenstrahlen spielen und Sie sich von ihnen verzaubern lassen dürfen.
          </p>
          <p><b>Liebe Grüße,</b></p>
          <div class="schuette-family">
            <logo-schuette class="family-logo" />Familie Schuette®
          </div>
        </div>
      </div>
    </div>
    <div class="categories-container">
      <div class="container-1000">
        <categories v-if="page" :categories="page.navigation" home full>
          <template #features="{identifier}">
            <template v-if="identifier === 'plisy'">
              <div class="category-feature">
                <div class="feature-icons">
                  <quick-icon />
                  <drilling-icon />
                  <no-drilling-icon />
                </div>
                <div class="feature-description">
                  Schnelle Montage (Mit oder Ohne Bohren)
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <collections-icon />
                  <colors-icon />
                </div>
                <div class="feature-description">
                  5 Kollektionen & 78 Farben
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <check-icon />
                  <strong-icon />
                </div>
                <div class="feature-description">
                  Schuette® Qualitätsversprechen
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-description">
                  Ab 15,99 EUR <br> Kostenloser Versand nach DE & AT
                </div>
              </div>
            </template>

            <template v-if="identifier === 'roletki'">
              <div class="category-feature">
                <div class="feature-icons">
                  <quick-icon />
                  <drilling-icon />
                  <no-drilling-icon />
                </div>
                <div class="feature-description">
                  Schnelle Montage (Mit oder Ohne Bohren)
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <collections-icon />
                  <colors-icon />
                </div>
                <div class="feature-description">
                  2 Kollektionen & 26 Farben
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <check-icon />
                  <strong-icon />
                </div>
                <div class="feature-description">
                  Schuette® Qualitätsversprechen
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-description">
                  Ab 11,99 EUR <br> Kostenloser Versand nach DE & AT
                </div>
              </div>
            </template>

            <template v-if="identifier === 'zaslony'">
              <div class="category-feature">
                <div class="feature-icons">
                  <quick-icon />
                </div>
                <div class="feature-description">
                  Schnelle Montage (Mit Ösen oder Gardinenband)
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <collections-icon />
                  <colors-icon />
                </div>
                <div class="feature-description">
                  2 Kollektionen & 32 Farben
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <check-icon />
                  <strong-icon />
                </div>
                <div class="feature-description">
                  Schuette® Qualitätsversprechen
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-description">
                  Ab 46,99 EUR <br> Kostenloser Versand nach DE & AT
                </div>
              </div>
            </template>

            <template v-if="identifier === 'relax'">
              <div class="category-feature">
                <div class="feature-icons">
                  <fabric-texture-icon />
                </div>
                <div class="feature-description">
                  100% Superfluff-Baumwolle und Millenium-Samt
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <collections-icon />
                  <colors-icon />
                </div>
                <div class="feature-description">
                  2 Kollektionen & 48 Farben
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-icons">
                  <check-icon />
                  <strong-icon />
                </div>
                <div class="feature-description">
                  Schuette® Qualitätsversprechen
                </div>
              </div>
              <div class="category-feature">
                <div class="feature-description">
                  Ab 9,99 EUR <br> Kostenloser Versand nach DE & AT
                </div>
              </div>
            </template>
          </template>

          <template #buttons="{identifier}">
            <nuxt-link v-if="identifier === 'plisy'" :to="localePath('categories-pleated-blinds')">
              <b-button type="is-primary" class="cta-primary" expanded rounded icon-right="arrow-right-bold">
                Plissee gestalten
              </b-button>
            </nuxt-link>
            <nuxt-link v-if="identifier === 'roletki'" :to="localePath('categories-roller-blinds')">
              <b-button type="is-primary" class="cta-primary" expanded rounded icon-right="arrow-right-bold">
                Rollo gestalten
              </b-button>
            </nuxt-link>
            <nuxt-link v-if="identifier === 'zaslony'" :to="localePath('categories-curtains')">
              <b-button type="is-primary" class="cta-primary" expanded rounded icon-right="arrow-right-bold">
                Vorhang gestalten
              </b-button>
            </nuxt-link>
            <nuxt-link v-if="identifier === 'relax'" :to="localePath('categories-relax')">
              <b-button type="is-primary" class="cta-primary" expanded rounded icon-right="arrow-right-bold">
                Bettwäsche gestalten
              </b-button>
            </nuxt-link>
          </template>
        </categories>
      </div>
    </div>
  </div>
</template>

<script>
import LazyVideo from 'marketplace-front-core/components/shared/LazyVideo.vue'
import Carousel from 'marketplace-front-core/components/shared/Carousel.vue'
import CarouselItem from 'marketplace-front-core/components/shared/CarouselItem.vue'
import isMobile from 'marketplace-front-core/mixin/isMobile.vue'
import AppImage from 'marketplace-front-core/components/shared/AppImage.vue'
import Categories from '../landing/Categories.vue'
import MiniCategories from '../landing/MiniCategories'
import RatingAverage from '../layout/RatingAverage'
import faq from './faq-de.js'

import LogoSchuette from '~/static/images/logo-schuette.svg?inline'
import NoDrillingIcon from '~/assets/images/homepage/nodrilling-square.svg?inline'
import DrillingIcon from '~/assets/images/homepage/drilling-square.svg?inline'
import QuickIcon from '~/assets/images/homepage/quick-outline-square.svg?inline'
import CollectionsIcon from '~/assets/images/homepage/collections-outline-square.svg?inline'
import ColorsIcon from '~/assets/images/homepage/colors-outline-square.svg?inline'
import StrongIcon from '~/assets/images/homepage/strong-outline-square.svg?inline'
import CheckIcon from '~/assets/images/homepage/check-square.svg?inline'
import FabricTextureIcon from '~/assets/images/homepage/fabric-texture.svg?inline'
import PleatedBlindsIcon from '~/assets/images/category/pb.svg?inline'
import RollerBlindsIcon from '~/assets/images/category/rb.svg?inline'
import CurtainsIcon from '~/assets/images/category/cr.svg?inline'
import AccessoriesIcon from '~/assets/images/category/ac.svg?inline'

import WelcomeVideoThree from '~/static/images/schuette-welcome-video-3.mp4'

export default {
  name: 'HomePageEn',
  components: {
    LazyVideo,
    Carousel,
    CarouselItem,
    Categories,
    MiniCategories,
    NoDrillingIcon,
    DrillingIcon,
    QuickIcon,
    CollectionsIcon,
    ColorsIcon,
    StrongIcon,
    CheckIcon,
    FabricTextureIcon,
    PleatedBlindsIcon,
    RollerBlindsIcon,
    CurtainsIcon,
    AccessoriesIcon,
    RatingAverage,
    LogoSchuette
  },
  mixins: [isMobile],
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      WelcomeVideoThree,
      carouselImages1: [
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-company-1.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-company-1.jpg',
          alt: 'Schuette®'
        },
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-company-2.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-company-2.jpg',
          alt: 'Schuette®'
        },
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-company-3.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-company-3.jpg',
          alt: 'Schuette®'
        }
      ],
      carouselImages2: [
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-quality-1.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-quality-1.jpg',
          alt: 'Schuette Vorhänge'
        },
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-quality-2.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-quality-2.jpg',
          alt: 'Schuette Plissee'
        },
        {
          src: 'https://img.schuette.shop/schuette/homepage/schuette-quality-3.jpg.webp',
          webpFallback: 'https://img.schuette.shop/schuette/homepage/schuette-quality-3.jpg',
          alt: 'Schuette Rollos'
        }
      ]
    }
  },

  head () {
    return {
      script: [{ type: 'application/ld+json', json: this.getFaqSchemaOrg }]
    }
  },
  computed: {
    getFaqSchemaOrg () {
      const entity = faq.map((x) => {
        return {
          '@type': 'Question',
          name: x.question.replace(/["]+/g, '&quot;'),
          acceptedAnswer: {
            '@type': 'Answer',
            text: x.answer.replace(/["]+/g, '&quot;')
          }
        }
      })
      const schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [...entity]
      }
      return schema
    },
    getSLLink () {
      return this.localePath({
        name: 'product',
        params: {
          productName: this.toSlugTitle({ name: this.getSLName }),
          productId: 66837
        }
      })
    },
    getSLName () {
      switch (this.currentLang) {
        // LINK_PRODUKCYJNY
        case 'en':
          return 'schuette-fitted-sheet-with-all-round-elastic-wow-collection-white-90-x-200-x-20-cm'
        case 'fr':
          return 'schuette-drap-housse-avec-elastique-circulaire-collection-wow-blanc-90-x-200-x-20-cm'
        case 'es':
          return 'sabana-bajera-schuette-con-elastico-integral-wow-coleccion-blanco-90-x-200-x-20-cm'
        case 'it':
          return 'lenzuolo-teso-schuette-con-elastico-integrale-wow-collezione-bianco-90-x-200-x-20-cm'
        default:
          return 'schuette-spannbettlaken-mit-rundumgummi-90-x-200-x-20-cm-wow-kollektion-weis'
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.carousel {
  margin-top: 32px;
}

.carousel-item {
  border-radius: 16px;
  overflow: hidden;
}

.grid-item {
  position: relative;
  // Własny kontekst stosu - wideo i przycisk sortowane tylko między sobą
  isolation: isolate;
}

.intro-photo-button {
  position: absolute;
  bottom: 16px;
  left: 50%;
  // translate3d + will-change: przycisk dostaje własną warstwę GPU, inaczej
  // Safari w trakcie animacji karuzeli rysuje warstwę <video> nad nim
  transform: translate3d(-50%, 0, 0);
  will-change: transform;
  z-index: 2;
  // mobile carousel, photo slides
  &--low {
    bottom: 10px;
  }
}
.box-gray-cta{
  margin-bottom: 64px;
  &:last-child{
    margin-bottom: 0;
  }
}
.button.cta-white{
  background-color: #fff;
  color: #000;
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  &:hover, &:focus, &:focus:not(:active), &:active{
    background-color: #fff;
    color: #000;
    border-color: transparent;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  }
  :deep(.icon){
    color: $primary;
    i{
      font-size: 16px !important;
    }
  }
}
.box-gray + .check-list-container{
  margin-bottom: 32px;
}
h3{
  font-weight: 600;
  font-size: 24px;
  margin: 24px 0;
}
.box-gray{
  border-radius: 16px;
  background-color: #f7f7f7;
  position: relative;
  overflow: hidden;

  .box-gray-title{
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 0;
    margin-bottom: 24px;
    @include touch{
      justify-content: center;
    }
    .box-gray-icon{
      flex-shrink: 0;
      width: auto;
      height: 44px;
    }
    // gap can't be negative, so pull the stars up under the title (h3 line-height keeps it visible)
    .rating-average{
      margin-top: -2px;
    }
  }
  h3{
    font-weight: 600;
    font-size: 24px;
    line-height: 1.3;
    margin: 0;
  }
  @include touch{
    margin-right: -25px;
    margin-left: -25px;
    border-radius: unset;
  }
  .is-flex{
    display: flex;
    // mobile: text -> image
    @include touch{
      flex-direction: column;
    }
    .text{
      flex: 0 0 60%;
      padding: 40px;
      @include touch{
        flex: none;
        padding: 32px 24px 48px;
      }
      > a{
        display: inline-block;
        margin-top: 24px;
        .cta-primary{
          box-shadow: none;
        }
        @include touch{
          width: 100%;
          button{
            width: 100%;
          }
        }
      }
    }
  }
  .links{
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 24px;
    a{
      display: flex;
      @include touch{
        width: 100%;
      }
      button{
        height: 40px;
        font-size: 14px;
        @include touch{
          width: 100%;
        }
      }
    }
  }
  .app-image{
    flex: 1 1 auto;
    min-width: 0;
    :deep(picture){
      display: block;
      height: 100%;
      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

</style>
